import { FlexBox, Link, LinkExternalIcon, Text } from '@blockworks/ui';
import { Bit } from '@blockworks/ui/factory';

import { VisualizationError } from '../../models';

const VisualizationErrorMessage = ({ error }: { error: VisualizationError }) => {
    return (
        <FlexBox alignItems="center" justifyContent="center" gap={2} h="full" w="full">
            <FlexBox col gap="xs" w={300} maxW="full">
                <Text size="sm" weight="bold" capitalize>
                    {error?.type} Error
                </Text>
                <Text size="xs">{error?.message}</Text>
                <FlexBox alignItems="center" gap="xs">
                    <Link target="_blank" href={`/visualizations/${error.visualizationId}/edit`}>
                        <Bit.div gap={1} alignItems="center" display="flex" className="text-primary" borderRadius="md">
                            Visualization {error.visualizationId} <LinkExternalIcon className="w-3 h-3" />
                        </Bit.div>
                    </Link>
                    <Link target="_blank" href={`/queries/${error.queryId}/edit`}>
                        <Bit.div gap={1} alignItems="center" display="flex" className="text-primary" borderRadius="md">
                            Query {error.queryId} <LinkExternalIcon className="w-3 h-3" display="inline-block" />
                        </Bit.div>
                    </Link>
                </FlexBox>
            </FlexBox>
        </FlexBox>
    );
};

export { VisualizationErrorMessage };
